import React from 'react';

interface ActiveToggleFieldProps {
  active: boolean;
  disabled?: boolean;
  onChange: (value: boolean) => void;
}

const ActiveToggleField = ({ active, disabled, onChange }: ActiveToggleFieldProps) => (
  <div className="usuario-form__field usuario-form__field--active">
    <span className="usuario-form__label">Ativo</span>
    <div className="usuario-form__active-control">
      <button
        type="button"
        className={`usuario-form__toggle ${active ? 'usuario-form__toggle--on' : ''}`}
        onClick={() => onChange(!active)}
        disabled={disabled}
        aria-pressed={active}
        aria-label={active ? 'Desativar' : 'Ativar'}
      >
        <span className="usuario-form__toggle-knob" />
      </button>
      <span className="usuario-form__active-text">{active ? 'Ativo' : 'Inativo'}</span>
    </div>
  </div>
);

export default ActiveToggleField;
